module.exports = __webpack_public_path__ + "img/debt-consolidation-icon.d39a1700.svg";